import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import "./index.css";
import "../../components/Dropdown/index.css";
import {
  CategoryButton,
  ListingTile,
  Button,
  SignInMenu,
  SignUpMenu,
  JobTile,
  UserMenu,
} from "../../components";
import {
  AddIcon,
  LocationIcon,
  ProfileCircleIcon,
  SearchIcon,
  StarIcon,
  TrendUpIcon,
} from "../../components/icons";
import { ForgotPassModal } from "../../components";
import { useDispatch, useSelector } from "react-redux";
import { getCurrentUser, selectAuth } from "../../features/auth/authSlice";
import UserMenuModals from "../../components/Modals/UserMenuModals";
import { Link, NavLink } from "react-router-dom";
import { useGetCategoriesQuery } from "../../features/supabase/usecase/categories";
import {
  useGetClassifiedsQuery,
  useViewImpressionClassifiedMutation,
} from "../../features/supabase/usecase/classifieds";
import Logo from "../../images/logo.png";
import { ListingTileSkeleton } from "../../components/Skeleton";
import JobTileSkeleton from "../../components/Skeleton/JobTileSkeleton";
import Observer from "@researchgate/react-intersection-observer";
import { debounce } from "../../lib";
import CategorySkeleton from "../../components/Skeleton/CategorySkeleton";
import storageService from "../../app/services/storageService";
import CategoryList from "../../components/CategoryList";
import { useGetAllLocationsQuery } from "../../features/supabase/usecase/locations";

const HomePage = () => {
  const location = useLocation();
  const [category_id, setCategoryId] = React.useState(-1);
  const [search, setSearch] = React.useState({
    category_id: -1,
    location_id: -1,
  });
  const dispatch = useDispatch();
  const user = useSelector(selectAuth);
  const [selectedLocation, setSelectedLocation] = React.useState(-1);
  const [popupSignInMenuOpen, setPopupSignInMenuOpen] = React.useState(false);
  const [popupSignUpMenuOpen, setPopupSignUpMenuOpen] = React.useState(false);
  const [openModal, setOpenModal] = React.useState("");
  const [showForgotModal, setShowForgotModal] = React.useState(false);

  const { data: categories, error, isLoading } = useGetCategoriesQuery();
  const [isMobile, setIsMobile] = React.useState(false);

  const [viewImpressionClassified] = useViewImpressionClassifiedMutation();

  const {
    data: result,
    classifiedError,
    isLoading: isClassifiedLoading,
    isFetching,
    refetch: refetchClassifieds,
  } = useGetClassifiedsQuery({ search, limit: isMobile ? 10 : 3 });

  const {
    data: locations,
    error: locationsError,
    isLoading: locationsLoading,
  } = useGetAllLocationsQuery();

  const [open, setOpen] = React.useState(false);

  useEffect(() => {
    dispatch(getCurrentUser());
  }, [dispatch]);

  useEffect(() => {
    if (window.innerWidth < 768) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setIsMobile(true);
      } else {
        setIsMobile(false);
      }
    }
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    }
  }, [window.innerWidth])

  // useEffect(() => {
  //   debounce(async () => {
  //     // console.log("searching", category_id, selectedLocation);
  //     // setSearch({ category_id: category_id, location_id: selectedLocation });
  //   }, 800);
  // }, [category_id, selectedLocation]);

  const generateSearchUrl = () => {
    if (category_id === -1) return;

    let url = `/categories/1/?pg=1`;

    if (category_id !== -1) {
      url = `/categories/${category_id}/?pg=1`;
    }

    if (category_id !== -1 && selectedLocation !== -1) {
      url += `&location_id=${selectedLocation}`;
    }

    return url;
  };

  const [isTop, setIsTop] = React.useState(true);

  useEffect(() => {
    document.addEventListener("scroll", () => {
      if (window.scrollY > 20) {
        setIsTop(false);
      } else {
        setIsTop(true);
      }
    });
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get("login") === "true") {
      const button = document.querySelector(".banner-submit-button.login");
      if (button) button.click();
    }
  }, [location]);

  return (
    <div>
      <div className="banner">
        <div className={`banner-header ${!isTop && "scroll"} flex-row`}>
          <a className="banner-header-logo" href="https://collive.com/">
            <img src={Logo} alt="Colive" />
          </a>
          <div className={`banner-header-action`}>
            <div className="profile-btn">
              {!user.user ? (
                <button
                  className="banner-submit-button login"
                  onClick={() => setPopupSignInMenuOpen((val) => !val)}
                >
                  Login / Sign Up
                </button>
              ) : (
                <ProfileCircleIcon
                  size={36}
                  fill={"rgb(0, 0, 0, 0)"}
                  onClick={() => setPopupSignInMenuOpen((val) => !val)}
                  className={"profile-btn-icon"}
                />
              )}
              {window.innerWidth < 768 && !user.user && (
                <ProfileCircleIcon
                  id="profile-icon"
                  size={36}
                  fill={"rgb(0, 0, 0, 0)"}
                  onClick={() => setPopupSignInMenuOpen((val) => !val)}
                  className={"profile-btn-icon"}
                />
              )}
              {!user.user
                ? popupSignInMenuOpen && (
                  <SignInMenu
                    onSignUpClick={() => setPopupSignUpMenuOpen(true)}
                    isOpen={popupSignInMenuOpen}
                    setIsOpen={setPopupSignInMenuOpen}
                    showForgotModal={showForgotModal}
                    setShowForgotModal={setShowForgotModal}
                    closeModal={() => {
                      setPopupSignInMenuOpen(false);
                    }}
                  />
                )
                : popupSignInMenuOpen && (
                  <UserMenu
                    isOpen={popupSignInMenuOpen}
                    setIsOpen={setPopupSignInMenuOpen}
                    setOpenModal={setOpenModal}
                  />
                )}
              <UserMenuModals
                modal={openModal}
                onClose={() => setOpenModal("")}
              />
              {popupSignUpMenuOpen && (
                <SignUpMenu
                  onSignInClick={() => setPopupSignInMenuOpen(true)}
                  isOpen={popupSignUpMenuOpen}
                  setIsOpen={setPopupSignUpMenuOpen}
                  closeModal={() => {
                    setPopupSignUpMenuOpen(false);
                  }}
                />
              )}
              {showForgotModal && (
                <ForgotPassModal
                  isOpen={showForgotModal}
                  setIsOpen={setShowForgotModal}
                  goToSignIn={() => {
                    setShowForgotModal(false);
                  }}
                />
              )}
            </div>
          </div>
        </div>
        <div className="banner-body flex-col">
          <div className="banner-body-text">
            <span className="text-header">Classifieds</span>
            <div className="banner-body-description">
              <span className="text-gray text-medium text-sm">
                Find the latest classified listings
              </span>
              <span className="text-gray text-medium text-sm">
                &nbsp;powered by COLlive.com
              </span>
            </div>
          </div>
          <div className="flex-row search">
            <div className="search-select">
              <SearchIcon fill={"none"} size={20} className={"search-icon"} />
              <select
                value={category_id}
                onChange={(e) => setCategoryId(Number(e.target.value))}
              >
                <option value={-1}>All Categories</option>
                {categories?.map((category) => (
                  <option value={category.id}>{category.name}</option>
                ))}
              </select>
            </div>
            <div className="search-select">
              <LocationIcon
                fill={"rgba(0, 0, 0, 0)"}
                size={20}
                className={"search-icon"}
              />
              <select
                onChange={(e) => setSelectedLocation(Number(e.target.value))}
              >
                <option value={-1}>All Locations</option>
                {!locationsLoading &&
                  locations.map(({ location, id }) => {
                    return <option value={id}>{location}</option>;
                  })}
              </select>
            </div>
            <NavLink
              to={generateSearchUrl()}
              className={`search-button ${category_id === -1 ? "disabled" : ""
                }`}
            >
              <SearchIcon fill={"transparent"} stroke={"white"} size={20} />
              Search
            </NavLink>
          </div>
          <NavLink to="/submit">
            <button className="banner-submit-button">
              Submit a Classified
            </button>
            {/* <button className="banner-submit-button mobile">Post</button> */}
          </NavLink>
          {/* <section className="category" title="Category">
            {isLoading ? (
              <div className="category-list">
                {Array(5)
                  .fill(0)
                  .map((_, i) => (
                    <CategorySkeleton key={i} />
                  ))}
              </div>
            ) : (
              <CategoryList categories={categories} />
            )}
          </section> */}
        </div>
      </div>
      <section className="category" title="Category">
        {isLoading ? (
          <div className="category-list">
            {Array(10)
              .fill(0)
              .map((_, i) => (
                <CategorySkeleton key={i} />
              ))}
          </div>
        ) : (
          <CategoryList categories={categories} />
        )}
      </section>
      <section title="body" className="home-body">
        {isClassifiedLoading ? (
          <>
            {Array(4)
              .fill(9)
              .map((_, i) => (
                <section title="loading" className="listing">
                  <span className="text-medium flex-row">
                    <div
                      className="skeleton"
                      style={{
                        width: 200,
                        height: 35,
                        borderRadius: 10,
                      }}
                    />
                    <div style={{ flex: 1 }} />
                    <div
                      className="skeleton"
                      style={{
                        width: 100,
                        height: 20,
                        borderRadius: 10,
                      }}
                    />
                  </span>
                  <div className="listing-grid">
                    {Array(3)
                      .fill(0)
                      .map((_, i) => (
                        <ListingTileSkeleton key={i} />
                      ))}
                  </div>
                </section>
              ))}
          </>
        ) : (
          <>
            {result
              .filter((category) => category.classifieds.length > 0)
              .map((category, index) => (
                <section title={category.name} className="listing">
                  <span
                    className="text-medium flex-row"
                    style={{
                      alignItems: "center",
                    }}
                  >
                    <img
                      className="listing-icon"
                      src={storageService.publicUrl(category.image)}
                      alt={category.name}
                    />
                    <NavLink to={`/categories/${category.id}?pg=1`} style={{ display: "flex", alignItems: "center", gap: 14 }} >
                      <span className="bold" style={{ color: '#851718', fontSize: 28 }} >{category.name}</span>
                      <span className="listing-view-button">View All</span>
                    </NavLink>
                  </span>
                  <div className="listing-grid">
                    {category.classifieds?.map((classified, i) => {
                      if (category.type == "job") {
                        return (
                          <JobTile
                            location={classified?.locations?.location}
                            price={classified?.properties?.salary}
                            title={classified.title}
                            description={classified.description}
                            id={classified.id}
                            postedOn={classified.created_at}
                            onIntersection={(event, unobserve) => {
                              if (event.isIntersecting) {
                                viewImpressionClassified(classified.id);
                                unobserve();
                              }
                            }}
                          />
                        );
                      }
                      return (
                        <ListingTile
                          facilities={classified.facilities}
                          sqft={classified?.properties?.location_sqft}
                          type={classified.featured ? "featured" : ""}
                          price={classified?.properties?.price}
                          rate={classified?.properties?.price_type}
                          images={classified?.properties?.images}
                          id={classified.id}
                          onIntersection={(event, unobserve) => {
                            if (event.isIntersecting) {
                              viewImpressionClassified(classified.id);
                              unobserve();
                            }
                          }}
                          title={classified.title}
                          description={
                            "Nice House For Sale on East New York and Albany Crown Heights Parking Large Backyard Air Right Lorem ipsum dolor sit amet, qui minim labore adipisicing minim sint cillum sint consectetur cupidatat."
                          }
                          isHomePage
                        />
                      );
                    })}
                  </div>
                </section>
              ))}
          </>
        )}

        {/* <section title="Jobs" className="listing">
          <span className="text-medium flex-row">
            <NavLink to={`/categories/4?page=1`}>
              <>
                <StarIcon size={35} fill={"white"} />
                <span className="bold">Jobs</span>
                <span className="recently-posted-tag">Recently Posted</span>
              </>
            </NavLink>
          </span>
          {isClassifiedLoading || isFetching ? (
            <div className="listing-section">
              {Array(3)
                .fill(0)
                .map((_, i) => (
                  <JobTileSkeleton key={i} />
                ))}
            </div>
          ) : (
            <div className="listing-section">
              {result
                ?.filter((classified) => classified.category_id === 4)
                ?.map((classified) => {
                  return (
                    <JobTile
                      location={classified?.locations?.location}
                      price={classified?.properties?.salary}
                      title={classified.title}
                      description={classified.description}
                      id={classified.id}
                      postedOn={classified.created_at}
                      onIntersection={(event, unobserve) => {
                        if (event.isIntersecting) {
                          viewImpressionClassified(classified.id);
                          unobserve();
                        }
                      }}
                    />
                  );
                })}
            </div>
          )}
        </section> */}
      </section>
      <div
        onClick={() => {
          setOpen((val) => !val);
        }}
        className={"floating-button " + (open ? "open" : "")}
      >
        <AddIcon size={40} stroke={"#fff"} />
      </div>
      {open && (
        <div style={{ position: "fixed", bottom: 90, right: 20, zIndex: 1000 }}>
          <Link
            to="/submit"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: "var(--lightRed)",
              borderRadius: "10px",
              color: "#fff",
              fontSize: 20,
              padding: "10px 20px",
              boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
              textDecoration: "none",
            }}
          >
            Post Classified
          </Link>
        </div>
      )}
    </div>
  );
};

export default HomePage;
